module.exports = "/education/components/dotsCarouselComponent-8ca523.html";